import { LitElement, html } from "lit";
import { docPopup, faSvg, titles } from "../styles.js";
import { fa } from "../../utils/widgets.js";
import { faExternalLinkAlt, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { QUALITYSCORE_GPS_VALUES } from "../../utils/utils.js";

/**
 * Location Precision Doc displays a synthetic summary of how Location Precision filter and map theme works.
 * @class Panoramax.components.menus.LocationPrecisionDoc
 * @element pnx-location-precision-doc
 * @extends [lit.LitElement](https://lit.dev/docs/api/LitElement/)
 * @example
 * ```html
 * <pnx-location-precision-doc ._t=${viewer._t} />
 * ```
 */
export default class LocationPrecisionDoc extends LitElement {
	static styles = [ titles, faSvg, docPopup ];

	render() {
		return html`
			<h4>${fa(faMapMarkerAlt)} ${this._t?.pnx.filter_gps_precision}</h4>
			<p>${this._t?.pnx.filter_gps_precision_help_1}</p>
			<p>${this._t?.pnx.filter_gps_precision_help_2}</p>
			<pnx-grade-filter grade=""></pnx-grade-filter>
			<p>${this._t?.pnx.filter_gps_precision_help_3
				.replace("{p5}", QUALITYSCORE_GPS_VALUES[1])
				.replace("{p1}", QUALITYSCORE_GPS_VALUES[7])
				.replace(/\.01/g, "")
			}</p>
			<p>${this._t?.pnx.filter_gps_precision_help_4}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/#gps-position-accuracy"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${fa(faExternalLinkAlt)} ${this._t?.pnx.popup_details_link}</pnx-link-button>
		`;
	}
}

customElements.define("pnx-location-precision-doc", LocationPrecisionDoc);
